import http from '@/api/http'
import { IPartner, IPagination } from '@/utils/types'
import qs from 'qs'

export const getPartner = (id: number, params: IPagination) =>
    http({
        url: '/partners/' + id,
        method: 'get',
        params,
        paramsSerializer: params => {
            return qs.stringify(params)
        }
    })

export const getPartners = () => http.get('/partners')

export const updatePartner = (partner: IPartner) => http.put('/partners/' + partner.id, partner)

export const deletePartner = (parternId: string) => http.delete('/partners/' + parternId)

export const getStaplesStores = () => http.get('/partners/getstaplesstores')

export const importPartnerOrder = (partnerId: string, orderId: string, overwrite: boolean) => http.post(`/partners/importorder/${partnerId}/${orderId}?overwrite=${overwrite}`);

export const uploadPartnerOrder = (partnerId: string, file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    return http.post(`/partners/importorder/${partnerId}`, formData, { headers: { "Content-Type": "multipart/form-data" } });
};